module.exports = __webpack_public_path__ + "static/media/BIM 360 Ops.df87284b.png";